/* eslint-disable no-unused-vars */
var json_variable = {
	"information": {
		"videourl": [
			"https://d1dejaj6dcqv24.cloudfront.net/presentations/rsa2011/video/how-qualysguard-can-assist-security-professionals-protect-their-assets.mp4",
			"https://d1dejaj6dcqv24.cloudfront.net/presentations/rsa2011/video/how-qualysguard-can-assist-security-professionals-protect-their-assets.webm",
			"https://d1dejaj6dcqv24.cloudfront.net/presentations/rsa2011/video/how-qualysguard-can-assist-security-professionals-protect-their-assets.ogg"
		],
		"slideurl": "https://d1dejaj6dcqv24.cloudfront.net/presentations/how-qualysguard-can-assist-security-professionals-protect-their-assets/",
		"title": "Presentation Title",
		"date": "10-1-2012",
		"time": "8:00 AM",
		"offset": 0
	},
	"presenters": [],
	"slides": [{
		"time": "00:00:00",
		"title": "Expanding Your VM Program Into Policy...",
		"url": "Slide1.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:01:21",
		"title": "Leader-Led, but Includes Everyone",
		"url": "Slide2.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:02:09",
		"title": "Our Organization",
		"url": "Slide3.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:03:55",
		"title": "CSPO Audit Team",
		"url": "Slide4.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:05:26",
		"title": "The Growth of Vulnerability Management",
		"url": "Slide5.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:05:35",
		"title": "Vulnerability Management",
		"url": "Slide6.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:07:00",
		"title": "Chapter Title",
		"url": "Slide7.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:07:19",
		"title": "Know Your Network",
		"url": "Slide8.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:08:11",
		"title": "Qualys Scanner Deployment",
		"url": "Slide9.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:09:37",
		"title": "A (New) Problem with Size",
		"url": "Slide10.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:11:04",
		"title": "A Quick Refresher on IPv6, CIDR and Size",
		"url": "Slide11.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:13:46",
		"title": "We Need to Change How we Scan",
		"url": "Slide12.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:16:41",
		"title": "Scanning IPv6",
		"url": "Slide13.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:17:47",
		"title": "Web Application Scanning",
		"url": "Slide14.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:18:54",
		"title": "Why Web Application Scanning (External)",
		"url": "Slide15.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:20:30",
		"title": "Why Web Application Scanning (Internal)",
		"url": "Slide16.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:21:01",
		"title": "Why Web Application Scanning (Internal)",
		"url": "Slide17.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:24:38",
		"title": "A[nother] New Problem With Size",
		"url": "Slide18.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:24:45",
		"title": "Penetration Testing",
		"url": "Slide19.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:25:19",
		"title": "Penetration Testing",
		"url": "Slide20.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:25:58",
		"title": "Audit RTP Campus Network",
		"url": "Slide21.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:26:26",
		"title": "Client Connection Request",
		"url": "Slide22.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:27:48",
		"title": "Client Connection Exposure",
		"url": "Slide23.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:28:22",
		"title": "Vulnerability Management",
		"url": "Slide24.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:29:33",
		"title": "PCI Audit",
		"url": "Slide25.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:30:15",
		"title": "Qualys PCI",
		"url": "Slide26.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:31:24",
		"title": "Vulnerability Management - What's Next?",
		"url": "Slide27.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:32:06",
		"title": "Chapter Title",
		"url": "Slide28.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:21:58",
		"title": "In Summary",
		"url": "Slide29.jpg",
		"chapter": 1,
		"notes": ""
	}]
};
